<template>
  <PopupContent :bodyClass="['info-popup-body']">
    <template #header>
      <h2 class="title">{{ viewModel.title }}</h2>
    </template>

    <p class="message">{{ viewModel.message }}</p>

    <template #footer>
      <div class="actions">
        <button class="button" type="button" @click="viewModel.handleClose()">
          {{ viewModel.okText }}
        </button>
      </div>
    </template>
  </PopupContent>
</template>

<script setup lang="ts">
import type { InfoPopupViewModel } from '../popup-view-models/info-popup.view-model';
import PopupContent from './PopupContent.vue';

interface Props {
  readonly viewModel: InfoPopupViewModel;
}

defineProps<Props>();
</script>

<style scoped>
.info-popup-body {
  color: #333;
}

.title {
  margin: 0;
  font-size: var(--font-size-subheader);
}

.message {
  margin: 0;
  color: #555;
  line-height: 1.4;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.button {
  background: #6c757d;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: var(--font-size-menu);
  cursor: pointer;
  transition: all 0.2s;
}

.button:hover {
  background: #5a6268;
}
</style>


